import { Box, Typography, Modal, Grid, Stack } from '@mui/material';
import { Button, IconButton } from '@material-ui/core';
import CloseIcon from '@mui/icons-material/CloseRounded';

interface Props {
    openModal: boolean;
    setOpenModal: Function;
    message: string;
    onButtonSubmit: any;
    data: {
        name: string;
        lastname: string;
        nit: string;
        phone: string;
        email: string;
    };
}

const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    minWidth: 250,
    bgcolor: 'background.paper',
    borderRadius: '10px',
    boxShadow: 24,
    p: 5,
};

export const ModalDataConfirm = (props: Props) => {
    const { openModal, setOpenModal, onButtonSubmit, message, data } = props;
    const color = localStorage.getItem('primaryColor') || '';

    return (
        <div>
            <Modal open={openModal} onClose={() => setOpenModal(true)}>
                <Box sx={style}>
                    <Grid container>
                        <Grid
                            item
                            sx={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                right: 0,
                                p: 1,
                                bgcolor: '#f2f4f9',
                                borderRadius: '10px',
                                display: 'flex',
                                justifyContent: 'end',
                            }}
                        >
                            <IconButton onClick={() => setOpenModal(false)}>
                                <CloseIcon />
                            </IconButton>
                        </Grid>
                    </Grid>
                    <Typography id="modal-modal-description" variant="h5" sx={{ mt: 2.5 }}>
                        {message}
                    </Typography>
                    {data.name && (
                        <Typography style={{ fontSize: '14px' }} sx={{ mt: 2 }}>
                            Nombre: {data.name} {data.lastname}
                        </Typography>
                    )}
                    {data.nit && (
                        <Typography style={{ fontSize: '14px' }}>Documento: {data.nit}</Typography>
                    )}
                    {data.phone && (
                        <Typography style={{ fontSize: '14px' }}>Celular: {data.phone}</Typography>
                    )}
                    {data.email && (
                        <Typography style={{ fontSize: '14px' }} sx={{ mb: 2 }}>
                            Correo: {data.email}
                        </Typography>
                    )}

                    <Stack direction="row" spacing={2} justifyContent="center">
                        <Button
                            onClick={() => setOpenModal(false)}
                            variant="outlined"
                            style={{ width: '120px', height: '40px', fontSize: '12px' }}
                        >
                            Modificar
                        </Button>

                        <Button
                            style={{
                                width: '120px',
                                height: '40px',
                                fontSize: '12px',
                                backgroundColor: color,
                                color: '#FFFFFF',
                            }}
                            onClick={onButtonSubmit}
                            disabled={false}
                            variant="contained"
                            type="submit"
                        >
                            Enviar
                        </Button>
                    </Stack>
                </Box>
            </Modal>
        </div>
    );
};
